export default "__VITE_ASSET__Bi9eC0hk__"